import { FormattedMessage } from 'react-intl';

import type { ExpanderListItemBase } from '#components/shared/ExpanderListItemBase.ts';

import { type OrderStopFields, OrderStopForm } from './OrderStopForm.tsx';

export const OrderStopFormToExpanderListItem = (stop: OrderStopFields): ExpanderListItemBase => {
    const header =
        stop.type === 'load'
            ? 'intl-msg:ordercom-cloud-frontend.orders.details.stop.pick-up'
            : 'intl-msg:ordercom-cloud-frontend.orders.details.stop.delivery';
    return {
        id: `stop-${stop.type}-${stop.id}`,
        header: (
            <div data-testid={`order-stop-${stop.type}-${stop.id}`}>
                <FormattedMessage id={header} />
            </div>
        ),
        body: <OrderStopForm orderStop={stop} />,
    };
};
